module.exports = __webpack_public_path__ + "img/work-5.9abffbcc.png";